export default {
  referencePointEffectiveImpedance: "Reference point of the effective impedance",
  temporaryMinimumPerformance: "Temporary Minimum Performance",
  animation: {
    description: "Your filters produced no results. Please try again with adjusting or clearing your filters.",
    title: "No matching search results",
  },
  zerezIdforUnit: "ZEREZ ID for Unit",
  zerezIdforCertificate: "ZEREZ ID for Certificate",
  certificateCheck: "Certificate Check",
  certificateHistory: "Certificate History",
  certificateSequence: "Certificate Sequence",
  instantaneousReserve: "Inertia",
  requestMatrixParametersText: "Request access to Inertia parameters",
  accessApprovedMatrixParametersText: "Access to Inertia parameters approved",
  parameterView: "Parameter View",
  certificateHistoryClose: "Close Certificate History",
  certificateHistoryIssues: {
    "4e7118b6-4883-567a-b4ad-ab245717ff08": "Error reported",
    "9524be5a-6656-548a-a3c1-754b20df564a": "Certificate verified",
    "b3ef1a67-6644-568f-b8d2-898b2d897562": "Imported",
    "b01df1c0-0ea3-5313-bd0c-54931887c428": "Error corrected",
  },
  certificateHistoryIssueTypesAndStatus: {
    "4e7118b6-4883-567a-b4ad-ab245717ff08": {
      // error report
      "24c5e9ce-5ab1-5b2a-bdcf-9b72375ddbd6": "Error Report acknowledged",
      "3ef6203f-08a9-5d5b-abb7-a9f6140c0c88": "Error Report rejected",
      "5ab495d4-c024-5919-8a46-7bb6a350d901": "Error Report resolved",
      "dc7a63d2-6f9c-5604-ab6b-5e35656d017f": "Error Report closed by administration",
      default: "Error Report",
    },
    "9524be5a-6656-548a-a3c1-754b20df564a": {
      // certificate validation
      "2cb21769-d5e7-5c7b-92a9-66c7cec83c4a": "Upload", // new
      "c5aecfb8-5509-581c-a020-ee346f9775e2": "Upload Correction", // open
      "7e940e8c-3b72-586e-bd8b-82a8fbe9f497": "Correction completed", // pending review
      "dc7a63d2-6f9c-5604-ab6b-5e35656d017f": "Certificate verified", // closed
      "f29219b3-0298-512b-bf64-4dbcc7bfb99f": "TG8 conform upload", // newTG8
      "6c00e34b-d503-56c3-8992-5783701ebb43": "Certificate edited", // openTG8
      "d90ddbba-5776-5cee-bcd2-cda47bd798bf": "Validation restarted", // reopened
      "ab932a80-ee8e-5ab7-b70a-9ad957fac15f": "Reassignment by administration", // reassignment
      "451ff4cf-418a-50d9-96c0-ddaf6e920fb7": "Validity extension", // NewExtension
      "0b2e5b56-dc16-5210-a744-5396f2b6e892": "Replacement", // NewReplacement
      "3ef6203f-08a9-5d5b-abb7-a9f6140c0c88": "Correction demand", // rejected
      "1bb5e2c9-9b9a-59a4-8290-2d62fe246a7e": "VOID (by administration)", // VoidByPO
      "2644f649-0882-55fc-a26a-f0a250d71c1e": "Withdrawal (by authority)", // VoidByCB
      ERROR_IN_VERIFICATION_PROCESS: "Error in Verification Process", // error in verification process
      default: "Zertifikatsvalidierung",
    },
    "b3ef1a67-6644-568f-b8d2-898b2d897562": {
      // import
      default: "Import",
    },
    "b01df1c0-0ea3-5313-bd0c-54931887c428": {
      // error correction
      "c5aecfb8-5509-581c-a020-ee346f9775e2": "Edit", // open
      "13ef0cf5-fccb-5293-b7a6-7b1bdbe40da7": "Next edit", // in progress
      "7e940e8c-3b72-586e-bd8b-82a8fbe9f497": "Correction completed", // pending review
      "dc7a63d2-6f9c-5604-ab6b-5e35656d017f": "Correction confirmed", // closed
      "ab932a80-ee8e-5ab7-b70a-9ad957fac15f": "Reassignment by administration", // reassignment
      "451ff4cf-418a-50d9-96c0-ddaf6e920fb7": "Validity extension", // NewExtension
      "0b2e5b56-dc16-5210-a744-5396f2b6e892": "Replacement", // NewReplacement
      "3ef6203f-08a9-5d5b-abb7-a9f6140c0c88": "Correction demand", // rejected
      "1bb5e2c9-9b9a-59a4-8290-2d62fe246a7e": "VOID (by administration)", // VoidByPO
      "2644f649-0882-55fc-a26a-f0a250d71c1e": "Withdrawal (by authority)", // VoidByCB
      default: "Error Correction",
    },
  },
  certificateInfo: "Certificate Info",
  certificateStatus: "Certificate Status",
  certificateStatuses: {
    expired: "Expired",
    expiring: "Expiring",
    replaced: "Withdrawn (replaced by)",
    valid: "Valid",
    withdrawn: "Withdrawn (not replaced)",
  },
  description:
    "The FGW e.V. connects the energy industry and standardizes the technical language of decentralized and renewable energies. In this section, you will find unit- and component- certificates for various voltage levels. Here, you can verify whether these certificates have been reviewed by an accredited certification body and check their current validity status.",
  editParameters: "Edit Parameters",
  editCertificate: "Edit Certificate",
  errorNote: ({ entity, modelName }: { entity: "unit" | "certificate"; modelName: string | undefined }) => {
    let errorNote = `Please describe the issue you noticed within the ${modelName} certificate. Once the issue is resolved by the responsible party, you will be notified by email.`;
    if (entity === "unit")
      errorNote = `Please describe the issue you noticed within the unit ${modelName}. Once the issue is resolved by the responsible party, you will be notified by email.`;
    return errorNote;
  },
  unitEditWarning: {
    info: "You are currently editing the parameters of a unit. Possible changes might be lost. Please leave the edit mode to continue.",
    header: "Plesase leave the edit mode to continue.",
  },
  filterTitles: {
    certificateStatus: "Certificate Status",
    certificateType: "Type Of Verification Document",
    manufacturer: "Manufacturer",
    authority: "Certification Body",
    maxActivePower: "Max Active Power",
    norm: "Norm",
    ownCertificates: "Own Certificates",
    primaryEnergy: "Primary Energy",
    ratedPower: "Active Power",
    ratedVoltage: "Rated Voltage",
    subscribed: "Subscribed",
    verified: "Verified",
    isNotReplaced: "Only Current Revisions",
    zerezId: "ZEREZ ID",
    hasMatrixParameters: "Grid-forming unit",
    sortByCreatedAt: "Creation Date (Certificate)",
    sortByModifiedAt: "Modification Date (Certificate)",
    errorReportStatus: "Error Report Status",
    certificateHolder: "Certificate Holder",
  },
  label: "Units and Certificates",
  locked: "Locked",
  mostRecentCertificate: "Most Recent Certificate",
  notVerified: "Not Verified",
  verify: "Verify",
  referToDetailView: "refer to detail view",
  reportCertificateError: "Report Certificate Error",
  showUnit: "Go to Unit Detail Page",
  since: "since",
  subscribed: "Subscribed",
  subscribeStar: "Subscription",
  subscribe: "Subscribe",
  title: "ZEREZ - Central registry for unit and component certificates",
  unitParameters: {
    netFeed: "Type Info",
    electricalParameters: "Electrical Parameters",
    fastVoltageChanges: "Rapid Voltage Changes",
    operation1: "Switching Operation 1",
    operation2: "Switching Operation 2",
    operation3: "Switching Operation 3",
    flicker: "Flicker",
    generalInfo: "General Info",
    label: "Unit Parameters",
    powerRanking: "Power Ranking",
  },
  uploadedDocuments: "Uploaded Documents",
  units: "Units",
  noUnitsFound: "No units were found for your search entry",
  verified: "Verified",
  verificationPending: "Verification Pending",
  isErrorReportedUnresolved: "Unresolved Error Report",
  inCorrection: "Ongoing Feedback Process",
  linkToDetailPageOfModel: "Link to Detail Page of Unit",
  listOfConnectionValues: "List of Connection Values",
  zerezIDTextforPowerRange: "refer to range slider",
  requestLockedData: {
    sendRequest: "Send Request",
    title: "Request Access",
    selectAll: "Select all",
    selected: "selected",
    accessRequested: "...Access requested",
    accessDenied: "...Access denied",
    noRequestablesSelected: "To request access, please select the type of information you wish to access.",
    requestConnectionValuesText:
      "I want to have access to the complete list of grid connection values for all units covered by this certificate.",
    accessApprovedConnectionValuesText:
      "With your current permission you don’t have an access to the data bellow. To be able to see it request access.",
    requestAccesNetworkConnectionValues:
      "Access to some locked documents has already been requested by you or a member of your organization. You’ll receive an email notification once the certificate holder approves or declines the request",
    requestAccesNetworkConnectionValuesPending:
      "Access to some locked documents has already been requested by you or a member of your organization. You’ll receive an email notification once the certificate holder approves or declines the request",
    noMatrixParameterAccess: "You do not have permission to view the matrix parameters of this unit.",
    privacyNotice:
      "By submitting the request to view the documents, I agree that the organization that holds this certificate will receive my email address so that they can contact me if they have any questions!",
  },
  zerezIDForPowerRange: "ZEREZ ID for Power Range",
  historization: {
    open: "open",
    added: "added",
    updated: "updated",
    removed: "removed",
    errorReportCreatedByAt: ({ tenantName, createdAt }: { tenantName: string; createdAt: string }) =>
      `Reported by ${tenantName} on ${createdAt}`,
    originalErrorReportMessage: "Original error report message",
  },
  certificateWithTG8Rev25ConformityDisclaimer:
    "This verification document was uploaded in accordance with TR 8 Rev. 9. A ZEREZ ID will only be issued after all mandatory information has been completed.",
  certificateChainWithdrawWarningTitle: "Certificate is part of a chain",
  certificateChainWithdrawWarningDescription:
    "This certificate is part of an extension chain. If you set the validity status to 'withdrawn', the entire certificate chain will be withdrawn. Do you want to continue with editing?",
  certificateChainReplaceWarningDescription:
    "This certificate is part of an extension chain. If you replace the certificate, the entire certificate chain will be withdrawn. Do you want to continue with editing?",
  certificateChainWithdrawWarningConfirm: "Continue editing",
  certificateChainReplaceWarningConfirm: "Continue",
  certificateChainWithdrawWarningCancel: "Cancel",
  certificateChainList: "Certificates in this chain",
  reorderChain: {
    buttonLabel: "Reorder Chain",
    modalTitle: "Reorder Replacement Chain",
    description: "Drag and drop certificates on the right to rearrange the chain order.",
    currentOrderLabel: "Current Order",
    newOrderLabel: "New Order",
    baseCertificate: "Base",
    successor: "Revision",
    successMessage: "Certificate chain order updated successfully.",
    errorMessage: "Failed to update chain order.",
  },
  gridFormingUnitTooltip: "Grid forming Unit",
};
